/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
import { useState } from "react";

/**
 * @param {string} url
 * @param {Object} options
 * @returns
 */
export function useLazyFetch(url, options) {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);

  const postData = async (paramsString = "", overridingOptions = {}) => {
    setIsLoading(true);
    // A new request supersedes whatever the previous one left behind — a
    // network-level failure from an earlier call otherwise never clears, so
    // a later successful call for different params would still read as failed.
    setError(null);
    try {
      const res = await fetch(`${url}${paramsString}`, {
        credentials: "include",
        ...options,
        ...overridingOptions,
      });
      setResponseStatus(res?.status);
      const json = await res?.json();

      setResponse(json);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  };

  return {
    postData,
    response,
    responseStatus,
    error,
    isLoading,
  };
}

/**
 * @param {string} url
 * @param {Object} options
 * @returns
 */
export function useLazyPost(url, options) {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);

  const postData = async (body, paramsString = "") => {
    setIsLoading(true);
    // See useLazyFetch above: clear a previous call's failure so it can't
    // outlive a later successful one.
    setError(null);
    try {
      const res = await fetch(`${url}${paramsString}`, {
        credentials: "include",
        ...options,
        body: JSON.stringify(body),
      });
      setResponseStatus(res?.status || null);
      const json = await res?.json();

      setResponse(json);
    } catch (error) {
      setError(error);
    }
    setIsLoading(false);
  };

  return {
    postData,
    response,
    responseStatus,
    error,
    isLoading,
  };
}

export const getHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  return headers;
};
